export default {
  props: {
    isStep: {
      type: Boolean,
      default: false
    },
    template: {
    }
  },
  computed: {
    company() {
      return this.$store.getters.getConfig.PartnerName;
    },
    logo() {
      return this.$store.getters.getConfig.PartnerIcoURL;
    },
    fixedTemplate() {
      return this.template.Template.replace(/\n/gi, "<br/>");
    }
  }
};
